import txLogMonitorsFactory from '@exodus/tx-log-monitors';
import assetServersConfigAtomDefinition from './atoms/asset-servers-config.js';
import { isTxLogMonitorsSingleTickPlugin, isTxLogMonitorsSingleTickAtom, } from './tx-log-monitors-tick-plugin.js';
const txLogMonitorsDefinition = (...params) => {
    const feature = txLogMonitorsFactory(...params);
    return {
        ...feature,
        definitions: [
            ...feature.definitions,
            { definition: assetServersConfigAtomDefinition },
            { definition: isTxLogMonitorsSingleTickPlugin },
            { definition: isTxLogMonitorsSingleTickAtom },
        ],
    };
};
export default txLogMonitorsDefinition;
